import { GridColDef, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import Title from '../../custom/Title';
import { Box, Button, IconButton } from '@mui/material';
import {TRANSACTIONAL_REPORT_COLUMNS } from '../../../Models/report';
import ReportsTable from '../../custom/reportsTable';
import { useState } from 'react';
import moment, { Moment, MomentInput } from 'moment';
import { CalendarIcon, LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import SearchIcon from "@mui/icons-material/Search";
import styles from "./style.module.css";
import CircularModal from '../../custom/circularModalLoader/circularModalLoader';
import { getTransactionReport } from '../../../services/Reports';
import useService from '../../../hooks/useService';




const getTwoPointNumber = (number: number) => {
    return Number(number.toFixed(2));
  };

export const checkDateDifference = (fromDate: Date, toDate: Date) => {
    const fromDateObj = new Date(fromDate)
    const toDateObj = new Date(toDate)
    const differenceInTime = toDateObj.getTime() - fromDateObj.getTime()
    const differenceInDays = differenceInTime / (1000 * 3600 * 24)
  
    if (differenceInDays > 30) return true
    else return false
  }


export const TransactionalReport = () => {
    const [loading, setLoading] = useState<boolean>(false)
    const [rows, setRows] = useState([]);
    const [fromDate, setFromDate] = useState<any>(new Date().toString())
    const [toDate, setToDate] = useState<any>(new Date().toString())
    const { execute } = useService()




    const getReportColumns = (): GridColDef[] => {

        return Object.keys(TRANSACTIONAL_REPORT_COLUMNS).map(fieldName => {
            let minWidth = 200
            switch (fieldName as keyof typeof TRANSACTIONAL_REPORT_COLUMNS) {
                case 'Product Details':
                    minWidth = 450
                    break;
                case 'ProductName':
                    minWidth = 350;
                    break;
                case 'Product Name':
                    minWidth = 250;
                    break;
                case 'STO Remarks':
                    minWidth = 300
                    break;
            }
            return {
                field: fieldName,
                minWidth
            }
        })
    }

    const getTransactionReports = async () => {

        try {
            setLoading(true)
            let dateRange = checkDateDifference(fromDate, toDate)
            if (dateRange) return alert('Date range should be less than 30 days!')

            const params = {
                fromDate,
                toDate,
            }
            const { data } = await execute(() => getTransactionReport({params}))

            if (data?.data) {
                setRows(data?.data);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false)
            alert('Something went wrong')
        }
    }

    const CustomToolbar = () => {
        return (
          <GridToolbarContainer>
            <GridToolbarExport csvOptions={{ fileName: "Transaction report" }} />
          </GridToolbarContainer>
        )
    }

    const renderTable = () => {
        return (
            <Box sx={{ padding: "10px 0px" }}>
                {loading && <CircularModal thickness={4} />}

                <div style={{ height: '500px', overflow: 'auto' }}>
                    <ReportsTable
                        disableRowSelectionOnClick={true}
                        columns={getReportColumns()}
                        rows={rows}
                        // getRowId={(row: any) => {
                        //     const srNo = row["Sr. No."];
                        //     if (!srNo) {
                        //       console.error("Row does not have a unique 'Sr. No.' value");
                        //       return null; // or some fallback unique value
                        //     }
                        //     return srNo;
                        //   }}
                        getRowId={(row) => row.id || row["Sr. No."]} 
                        hideFooter={true}
                        fixedHeight={true}
                        rowHeight={50}
                        slots={{ toolbar: CustomToolbar }}
                    />
                </div>
            </Box>
        )
    }

    const filterModal = () => {
        return (
            <Box className={styles.filterModal}>
                <Box className={styles.filterModalRow}>
                    <Box className={styles.boxModal}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <MobileDatePicker
                                slotProps={{
                                    textField: { fullWidth: true, size: 'small' },
                                    field: {
                                        InputProps: {
                                            endAdornment: <IconButton><CalendarIcon /></IconButton>
                                        }
                                    }
                                }}
                                label='Start Date'
                                onChange={(value) => setFromDate(value?.toString()!)}
                                value={moment(fromDate)}
                            />
                        </LocalizationProvider>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <MobileDatePicker
                                slotProps={{
                                    textField: { fullWidth: true, size: 'small' },
                                    field: {
                                        InputProps: {
                                            endAdornment: <IconButton><CalendarIcon /></IconButton>
                                        }
                                    }
                                }}
                                label='End Date'
                                onChange={(value) => setToDate(value?.toString()!)}
                                value={moment(toDate || new Date().toString() as MomentInput)}
                            />
                        </LocalizationProvider>
                    </Box>
                    <Box >
                        <Button
                            variant="contained"
                            onClick={getTransactionReports}
                            endIcon={<SearchIcon />}
                            disabled={!fromDate}
                        >
                            Apply Filter
                        </Button>
                    </Box>
                </Box>
            </Box>
        )
    }

    return (
        <Box className={styles.container}>
            <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Transactional Report</Title>
            {filterModal()}
            {renderTable()}
        </Box>
    )
}